<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="$emit('tab-click')" stretch>
      <el-tab-pane v-for="tab in tabs" :label="tab.name" :name="tab.value" :key="tab.value">
        <CalculatorPartial ref="calculator" :type="tab.value" :currentPayTotal="currentPayTotal" @update:adjustPriceItem="$emit('update:adjustPriceItem', $event)" />
      </el-tab-pane>
    </el-tabs>
    <div style="margin-top: 24px;">
      <div style="display: flex; justify-content: space-between;">
        <div style="font-size: 18px;color: #000000;">備註</div>
        <el-button type="text" @click="$emit('update:textarea', '')">清空備註</el-button>
      </div>
      <el-input v-model="noteText" type="textarea" placeholder="請輸入內容" rows="5" />
    </div>
  </div>
</template>

<script>
import CalculatorPartial from './CalculatorPartial.vue'

export default {
  name: 'CalculatorOrderPricePane',
  components: {
    CalculatorPartial,
  },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    activeName: {
      type: String,
      default: 'add',
    },
    currentPayTotal: {
      type: Number,
      default: 0,
    },
    textarea: {
      type: String,
      default: '',
    },
  },
  computed: {
    activeTab: {
      get() {
        return this.activeName
      },
      set(val) {
        this.$emit('update:activeName', val)
      },
    },
    noteText: {
      get() {
        return this.textarea
      },
      set(val) {
        this.$emit('update:textarea', val)
      },
    },
  },
  methods: {
    clearInputByTab(tabName) {
      const idx = this.tabs.findIndex((tab) => tab.value === tabName)
      if (idx !== -1 && this.$refs.calculator && this.$refs.calculator[idx]) {
        this.$refs.calculator[idx].clearInput()
      }
    },
  },
}
</script>
